import React, { createContext, useContext, useState } from "react";
import { IManagerContext, IManagerMessage } from "../exports/interfaces";

const ManagerContext = createContext<IManagerContext>({
  managerData: [],
  setManagerData: () => null,
});
export const useManagerContext = () => useContext(ManagerContext);

export const ManagerProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [managerData, setManagerData] = useState<IManagerMessage[]>([]);

  return (
    <ManagerContext.Provider value={{ managerData, setManagerData }}>
      {children}
    </ManagerContext.Provider>
  );
};
